/* eslint-disable no-unused-vars */
import {AdsPopup} from '@/plugins/api'
import axios from 'axios'
export default {
  namespaced: true,
  state: {
    filterParams: {},
    items: [],
    count: 0
    //
  },
  actions: {
    async fetchItems({commit, state}, params = {}) {
      const filterParams = {...state.filterParams, ...params}
      const items = await AdsPopup.fetch({...filterParams})
      commit('changeState', {filterParams, items})
    },
    async countItems({commit, state}, params = {}) {
      const {_sort, populates, ...filterParams} = {...state.filterParams, ...params}
      const count = await AdsPopup.count({...filterParams})
      commit('changeState', {count})
    },
    //
    createItem(_, data = {}) {
      return AdsPopup.create(data)
    },
    updateItem(_, {id, ...data}) {
      return axios.put('/ads-popups/' + id, data)
    }
  },
  getters: {
    items: state => state.items,
    count: state => state.count
    //
  }
}
